import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconVariables: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-filled-radius-0-stroke-2-IconVariables"><Path fillRule="evenodd" clipRule="evenodd" d="M2.98828 6.79757L11.999 1.59521L21.0098 6.79757V17.2023L11.999 22.4046L2.98828 17.2023V6.79757ZM11.999 14.4999C13.3797 14.4999 14.499 13.3807 14.499 11.9999C14.499 10.6192 13.3797 9.49994 11.999 9.49994C10.6183 9.49994 9.49902 10.6192 9.49902 11.9999C9.49902 13.3807 10.6183 14.4999 11.999 14.4999Z" fill="currentColor"/></CentralIconBase>;
});

export default IconVariables;
